import axios from "axios"


const base_url = "https://prep2go-en-es-api.vercel.app/lesson/"


const state = {
    info: [],
    levelLesson: {}
}

const getters = {
    getInfo(state) {
        return state.info
    },
    getLevelLesson(state) {
        return state.levelLesson
    }
}

const mutations = {
    setInfo(state, data) {
        state.info = data
    },
    setLevelLesson(state, data) {
        state.levelLesson = data
    }
}

const actions = {
    createLesson({ getters }, data) {
        return axios.post(`${base_url}create`, { ...data, token: getters.getToken })
    },
    updateLesson({ getters }, data) {
        return axios.post(`${base_url}update`, { ...data, token: getters.getToken })
    },
    deleteLesson({ getters }, data) {
        return axios.post(`${base_url}delete`, { ...data, token: getters.getToken })
    },
    info({ getters }) {
        return axios.get(`${base_url}info`, { params: { token: getters.getToken } })
    },
    getLessons({ getters }) {
        return axios.get(`${base_url}lessons`, { params: { token: getters.getToken } })
    },
    getLesson({ getters }, data) {
        return axios.get(`${base_url}lesson`, {
            params: {
                token: getters.getToken,
                level: data.level,
                lesson: data.lesson
            }
        })
    },
    finishAndNextLesson({ getters }, data) {
        return axios.post(`${base_url}finish&next`, { ...data, token: getters.getToken })
    },
    getStudies({ getters }, student) {
        return axios.get(`${base_url}studies`, { params: { student, token: getters.getToken } })
    },
    getAllStudies({ getters }) {
        return axios.get(`${base_url}allStudies`, { params: { token: getters.getToken } })
    }
}


export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/lesson.js